<!-- 答题页面 -->
<template>
    <div class="cquestion">
        <div class="cquestion_title">航天科普知识问答</div>
        <div class="cquestion_person"></div>
        <div class="cquestion_close" @click="handleClose"></div>
        <div class="cquestion_content">
            <div class="cquestion_content-title">
                <div class="cquestion_content-btn">单选题</div>
                <span>{{pageIndex}}/5</span>
            </div>
            <span class="cquestion_content-desc">{{questionTitle}}</span>
            <div
                class="cquestion_content-option"
                :class="optionSelected('A', optionA)"
                @click="() => handleClickOption(optionA)"
            >{{optionA.desc}}</div>
            <div
                class="cquestion_content-option"
                :class="optionSelected('B', optionB)"
                @click="() => handleClickOption(optionB)"
            >{{optionB.desc}}</div>
            <div
                class="cquestion_content-option"
                :class="optionSelected('C', optionC)"
                @click="() => handleClickOption(optionC)"
            >{{optionC.desc}}</div>
        </div>
        <div
            class="cquestion_nextbtn"
            :class="!isShowSelected ? 'disabledSelectedBtn' : ''"
            @click="handleGetMdedal"
        >{{btnText}}</div>
    </div>
</template>

<script>
import { questionsData } from '@/utils/questions';

export default {
    name: 'cquestion',
    data() {
        return {
            btnText: '下一题',
            // 用来计数
            pageIndex: 1,
            pageSize: 5,
            // 数据
            allQuestions: [],
            idata: {},
            // 是否展示选中结果效果
            isShowSelected: false,
            // 当前选中的选项
            isSelectedOption: '',
            // 答对题目数量
            isOkCount: 0
        }
    },
    created() {
        this.allQuestions = JSON.parse(JSON.stringify(questionsData));
        this.handleGetQuestion();
    },
    computed: {
        questionTitle() {
            const { title = '' } = this.idata;
            return title && `${this.pageIndex}、${this.idata.title}`;
        },
        optionA() {
            const { options = [] } = this.idata;
            return options[0];
        },
        optionB() {
            const { options = [] } = this.idata;
            return options[1];
        },
        optionC() {
            const { options = [] } = this.idata;
            return options[2];
        },
        optionSelected() {
            return function(flag, option) {
                return {
                    isok: this.isShowSelected && option.isAnswer,
                    iserror: this.isShowSelected && this.isSelectedOption === flag && !option.isAnswer,
                    disabledSelected: this.isShowSelected
                }
            }
        }
    },
    methods: {
        // 关闭操作
        handleClose() {
            this.$emit('close')
        },
        // 选中每个选项操作
        handleClickOption(option) {
            this.isShowSelected = true;
            this.isSelectedOption = option.id;
            if(option.isAnswer) {
                this.isOkCount++
            }

            if(this.pageIndex === this.pageSize) {
                this.btnText = '完成';
            }
        },
        // 随机获取1道题
        handleGetQuestion() {
            const index = Math.floor(Math.random()*(this.allQuestions.length-1));
            this.idata = {...this.allQuestions[index]};
            const newQuestions = this.allQuestions.filter(item => item.id !== this.idata.id);
            this.allQuestions = [...newQuestions];
            // 播放对应题目的讲解视频
            this.$emit('showVideo', this.idata.guid);
        },
        // 下一题按钮、答题完成按钮
        handleGetMdedal() {
            if(this.pageIndex === this.pageSize) {
                let result = '';
                if(this.isOkCount === this.pageSize) {
                    // 金牌
                    result = 'gold';
                } else if (this.isOkCount === this.pageSize - 1) {
                    // 银牌
                    result = 'sliver';
                } else {
                    // 同牌
                    result = 'bronze';
                }
                this.$emit('getMedal', result);
                this.btnText = '完成';
                return;
            }

            this.pageIndex = this.pageIndex + 1;
            this.isShowSelected = false;

            if(this.pageIndex <= this.pageSize) {
                this.btnText = '下一题';
                this.handleGetQuestion();
            }

            
        }
    }
}
</script>


<style scoped lang="scss">
.cquestion {
    position: absolute;
    z-index: 1;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    display: flex;
    flex-direction: column;
    justify-content: center;
    align-items: center;
    .cquestion_close {
        width: 42px;
        height: 42px;
        background: url('~@/assets/img/answer/answer-close-btn.png') no-repeat center;
        background-size: cover;
        position: absolute;
        top: 50px;
        right: -78px;
        cursor: pointer;
    }
    .cquestion_person {
        width: 230px;
        height: 596px;
        background: url('~@/assets/img/answer/answer-person.png') no-repeat center;
        background-size: cover;
        position: absolute;
        left: -190px;
        bottom: -5px;
    }
    .cquestion_title {
        font-size: 42px;
        font-family: SourceHanSansCN, SourceHanSansCN-Bold;
        font-weight: 700;
        text-align: left;
        color: #ffffff;
        margin-bottom: 20px;
    }
    .cquestion_content {
        width: 644px;
        height: 596px;
        background: #FFEAC4;
        border-radius: 20px;
        box-sizing: border-box;
        padding: 36px 32px;
        &-title {
            display: flex;
            justify-content: space-between;
            .cquestion_content-btn {
                width: 72px;
                height: 26px;
                border: 1px solid #FFB534;
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #FFB534;
                display: flex;
                justify-content: center;
                align-items: center;
            }
            span {
                font-size: 14px;
                font-family: Source Han Sans CN;
                font-weight: 500;
                color: #B2B2B2;
            }
        }
        &-desc {
            display: inline-block;
            font-size: 26px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #010101;
            margin-top: 22px;
            width: 100%;
            text-align: left;
        }
        &-option {
            width: 570px;
            min-height: 68px;
            height: auto;
            background: #DFDEDE;
            border-radius: 50px;
            margin-top: 26px;
            font-size: 24px;
            font-family: Source Han Sans CN;
            font-weight: 500;
            color: #010101;
            box-sizing: border-box;
            padding-left: 32px;
            padding-right: 32px;
            padding-top: 20px;
            padding-bottom: 20px;
            display: flex;
            justify-content: space-between;
            align-items: center;
            cursor: pointer;
            text-align: left;
        }
        .isok {
            border:2px solid #1DB100;
            position: relative;
            &::after {
                content: '';
                display: block;
                align-self: center;
                flex: none;
                margin-left: 8px;
                width: 25px;
                height: 16px;
                background: url('~@/assets/img/answer/answer-ok-icon.png') no-repeat;
                background-size: cover;
            }
        }
        .iserror {
            border: 2px solid #D90000;
            position: relative;
            &::after {
                content: '';
                display: block;
                align-self: center;
                flex: none;
                margin-left: 8px;
                width: 20px;
                height: 20px;
                background: url('~@/assets/img/answer/answer-error-icon.png') no-repeat;
                background-size: cover;
            }
        }
    }
    .cquestion_nextbtn {
        width: 494px;
        height: 72px;
        background: linear-gradient(0deg,#a65a00 5%, #ce7900 91%);
        border-radius: 36px;
        font-size: 24px;
        font-family: SourceHanSansCN, SourceHanSansCN-Medium;
        font-weight: 500;
        color: #ffffff;
        margin-top: 26px;
        display: flex;
        align-items: center;
        justify-content: center;
        cursor: pointer;
    }
    .disabledSelected {
        cursor: not-allowed;
        pointer-events: none;
    }
    .disabledSelectedBtn {
        cursor: not-allowed;
        pointer-events: none;
        background: #DFDEDE;
        color: #010101;
    }
}
</style>